import { useAuth } from '../../providers/AuthProvider';

interface Props {
  perm: string;
  children: React.ReactNode;
}

export function RequirePermission({ perm, children }: Props) {
  const { hasPerm } = useAuth();

  if (!hasPerm(perm)) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-700 dark:text-gray-300">Access Denied</h2>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
            You don't have the "{perm}" permission to access this page.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
